import { makeStyles } from '@material-ui/core';

export const useEditorChipStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    minHeight: '28px',
    padding: '2px 8px',
    borderRadius: '4px',
    // Figma selected-blue #D8E2FF is not yet in theme.palette.colors.
    backgroundColor: '#d8e2ff',
    boxSizing: 'border-box',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: theme.palette.colors.bluePrimaryMain,
  },
  name: {
    color: theme.palette.primary.deep,
    fontWeight: '700 !important',
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0.28px',
    textTransform: 'capitalize',
  },
  rootMuted: {
    backgroundColor: theme.palette.colors.grey20,
  },
  contentMuted: {
    color: theme.palette.colors.grey110,
  },
  nameMuted: {
    color: theme.palette.colors.grey110,
  },
  removeButton: {
    padding: '2px',
    marginLeft: '2px',
    color: theme.palette.primary.deep,
  },
}));
